// Configuration for the optional MewMail Apps Script backend.
//
// MewMaps itself uses no Apps Script and requests no email/script scopes. Sending
// notification emails (and attaching the form to its responses sheet) is done by the
// separate `mewmail` Apps Script library, which the user installs into their responses
// sheet's bound script and runs once. The helpers here build the snippet and surface the
// library id the user needs to install it.

// Published scriptId of the MewMail library (see mewmail/.clasp.json). It is NOT on the
// Apps Script marketplace, so the project developer must share read access with each user.
export const MEWMAIL_LIBRARY_SCRIPT_ID =
  "13-TXS_Bk3y5tet7aZIOcmHvhf4VYV7O1818VRSFcEeRrqdKZkFP3EGdf";

// The identifier the user must give the library when adding it (Libraries ▸ + ▸ paste id).
// The generated code references the library through this name (e.g. `MewMail.setup(...)`).
export const MEWMAIL_LIBRARY_IDENTIFIER = "MewMail";

export interface BackendCodeIds {
  dataSpreadsheetId: string;
  formId: string;
  responsesSheetId: string;
}

// Builds the Code.gs the user pastes into their responses sheet's Apps Script project.
// All three IDs are inlined and passed to the library on every call, so the library never
// relies on its own (shared) script properties. The host owns the onFormSubmit trigger so
// it runs in the host project with this config.
export function buildBackendCode({ dataSpreadsheetId, formId, responsesSheetId }: BackendCodeIds): string {
  return `// MewMaps email backend — paste into your responses sheet's Apps Script
// (Extensions ▸ Apps Script), after adding the "${MEWMAIL_LIBRARY_IDENTIFIER}" library.
var MEW_CONFIG = {
  dataSpreadsheetId: '${dataSpreadsheetId}',
  formId: '${formId}',
  responsesSheetId: '${responsesSheetId}',
};

function setup() {
  var result = ${MEWMAIL_LIBRARY_IDENTIFIER}.setup(MEW_CONFIG);
  installOnFormSubmitTrigger_();
  return result;
}

function onFormSubmit(e) {
  return ${MEWMAIL_LIBRARY_IDENTIFIER}.onFormSubmit(e, MEW_CONFIG);
}

// Installs the form-submit trigger in THIS project so onFormSubmit runs here with MEW_CONFIG.
function installOnFormSubmitTrigger_() {
  var triggers = ScriptApp.getProjectTriggers();
  for (var i = 0; i < triggers.length; i++) {
    if (triggers[i].getHandlerFunction() === 'onFormSubmit') return;
  }
  ScriptApp.newTrigger('onFormSubmit')
    .forForm(FormApp.openById(MEW_CONFIG.formId))
    .onFormSubmit()
    .create();
}
`;
}
